import styled from 'styled-components';
import { colors } from '@10d/tend-ui-tokens/samolet';

export const Wrapper = styled.div`
  color: ${colors.gray900};
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const Label = styled.div`
  margin-bottom: 16px;
`;

export const EmptyDescriptionBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  color: ${colors.gray900};
`;
